import { VSElementModel } from 'js/types';

export const isSVGElement = (element?: VSElementModel): boolean => {
  if (!element || element.type !== 'Image' || !element.image) {
    return false;
  }

  return element.image.contentType.includes('svg');
};
